<template>
  <div class="ion-page" main>
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-menu-toggle>
            <ion-button>
              <ion-icon slot="icon-only" ios="ios-menu" md="md-menu"></ion-icon>
            </ion-button>
          </ion-menu-toggle>
        </ion-buttons>
        <ion-title>Forms</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="reloadForms()">
            <ion-icon ios="ios-refresh" md="md-refresh"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-refresher slot="fixed" @ionRefresh="reloadForms(undefined, $event)">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <ion-segment :mode="style" :value="segment" color="primary" @ionChange="segmentChanged($event)">
        <ion-segment-button :mode="style" value="all">
          <ion-label>
            <ion-icon item-start ios="ios-clipboard" md="md-clipboard"></ion-icon>
            <span class="text">All</span>
          </ion-label>
        </ion-segment-button>
        <ion-segment-button :mode="style" value="pending">
          <ion-label>
            <ion-icon item-start ios="ios-cloud-upload" md="md-cloud-upload"></ion-icon>
            <span class="text">Pending</span>
          </ion-label>
        </ion-segment-button>
      </ion-segment>
      <ion-searchbar type="search" color="light" autocomplete="on" autocorrect="on" placeholder="Search..." :value="search" @ionInput="searchForms"></ion-searchbar>
      <ion-card color="light" v-if="loading == false && forms.length == 0">
        <ion-card-content>
          <h2 class="ion-padding">
            There currently are no <span v-if="showPending">pending</span> forms<span v-if="hasSearch">
              for <i>{{ search }}</i></span
            >, <a href="#" @click="createForm">create a form</a> now.
          </h2>
        </ion-card-content>
      </ion-card>
      <ion-card color="light" v-if="loading == false && (user.upgraded == null || user.upgraded == '')">
        <ion-card-content>
          <h2 class="ion-padding">Psst, you're still using the free version, <a href="#" @click="userUpgrade">upgrading</a> let's you create as many forms as you want.</h2>
        </ion-card-content>
      </ion-card>
      <card-form tappable :form="form" :key="form.id" v-for="form in forms" @click.native="showForm(form)"></card-form>
      <ion-infinite-scroll threshold="100px" @ionInfinite="moreForms($event)">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
      <ion-fab class="fab" vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button tappable @click="createForm">
          <ion-icon ios="ios-add" md="md-add"></ion-icon>
        </ion-fab-button>
        <!-- <ion-fab-list side="top">
          <ion-fab-button tappable @click="importForm">
            <ion-icon ios="ios-download" md="md-download"></ion-icon>
          </ion-fab-button>
          <ion-fab-button tappable @click="createForm">
            <ion-icon ios="ios-create" md="md-create"></ion-icon>
          </ion-fab-button>
        </ion-fab-list>-->
      </ion-fab>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import User from "../models/User";
import Form from "../models/Form";
import Forms from "../models/Forms";
import Entry from "../models/Entry";
import FormDetails from "./FormDetails.vue";
import FormEdit from "./FormEdit.vue";
import FormImport from "./FormImport.vue";
import UserUpgrade from "./UserUpgrade.vue";
import CardForm from "../components/CardForm.vue";
export default {
  name: "form-list",
  components: {
    CardForm
  },
  mixins: [Helpers, Plugins],
  data() {
    return {
      offset: 0,
      limit: 10,
      search: "",
      loading: false,
      segment: "all",
      style: "ios",
      maxRetries: 1,
      forms: new Forms()
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser();
    },
    showPending() {
      return this.segment == "pending";
    },
    hasSearch() {
      return this.search && this.search.length > 0;
    }
  },
  created() {
    this.loading = true;
    this.showStatusBar();
  },
  async mounted() {
    let loading = await this.showLoading();
    await this.reloadForms(loading);
    loading.dismiss();
  },
  methods: {
    async reloadForms(loading = undefined, event = undefined, retries = 0) {
      this.loading = true;
      try {
        // await this.uploadForms(loading, event);
        // await this.uploadEntries(loading, event);
        await this.loadForms(loading, event);
      } catch (error) {
        if (this.expiredToken(error) && retries <= this.maxRetries) {
          await this.$store.dispatch("userRefresh");
          this.reloadForms(loading, event, retries + 1);
        } else {
          this.showWarning(error);
        }
      } finally {
        this.loading = false;
        if (event && event.target) {
          event.target.complete();
        }
      }
    },
    async loadForms(loading, event = undefined) {
      this.offset = 0;
      if (loading) {
        loading.message = "Loading...";
      }
      if (this.showPending) {
        let formsPending = await Forms.pending(this.search, this.offset, this.limit);
        this.forms = formsPending.sortDesc("created");
      } else {
        if (this.hasConnection()) {
          let formsLoaded = await Forms.load(this.search, this.offset, this.limit);
          await formsLoaded.store();
        }
        let formsRestored = await Forms.restore(this.search, this.offset, this.limit);
        this.forms = formsRestored.sortDesc("created");
      }
    },
    async uploadForms(loading, event = undefined) {
      if (loading) {
        loading.message = "Uploading...";
      }
      let forms = await Forms.pending();
      for (let form of forms) {
        let saved = await form.save();
        saved.pending = false;
        await saved.store();
      }
    },
    async uploadEntries(loading, event = undefined) {
      if (loading) {
        loading.message = "Uploading...";
      }
      let entries = await Entries.pending();
      for (let entry of entries) {
        let saved = await entry.save();
        saved.pending = false;
        await saved.store();
        await this.form.touch();
        await this.form.store();
      }
    },
    async moreForms(event = undefined, retries = 0) {
      try {
        this.offset = this.offset + this.limit;
        if (this.hasConnection()) {
          let formsLoaded = await Forms.load(this.search, this.offset, this.limit);
          await formsLoaded.store();
        }
        let formsRestored = await Forms.restore(this.search, this.offset, this.limit);
        this.forms = formsRestored.sortDesc("created");
      } catch (error) {
        if (this.expiredToken(error) && retries <= this.maxRetries) {
          await this.$store.dispatch("userRefresh");
          this.offset = this.forms.length;
          await this.moreForms(event, retries + 1);
        } else {
          this.showWarning(error);
        }
      } finally {
        if (event && event.target) {
          event.target.complete();
        }
      }
    },
    async searchForms(event, retries = 0) {
      try {
        this.search = event.target.value;
        this.offset = this.offset + this.limit;
        if (this.hasConnection()) {
          let formsLoaded = await Forms.load(this.search, this.offset, this.limit);
          await formsLoaded.store();
        }
        let formsRestored = await Forms.restore(this.search, this.offset, this.limit);
        this.forms = formsRestored.sortDesc("created");
      } catch (error) {
        if (this.expiredToken(error) && retries <= this.maxRetries) {
          await this.$store.dispatch("userRefresh");
          await this.searchForms(event, retries + 1);
        } else {
          this.showWarning(error);
        }
      }
    },
    async createForm(event = undefined) {
      if (event) {
        event.preventDefault();
      }
      if (this.forms.length == 0) {
        let modal = await this.showModal(FormEdit);
        let dismissed = await modal.onDidDismiss();
        if (dismissed && dismissed.data && dismissed.data.form) {
          let loading = await this.showLoading("Loading...");
          await this.loadForms();
          loading.dismiss();
        }
      } else {
        this.showUpgrade(this.createForm);
      }
    },
    async importForm() {
      if (this.forms.length == 0) {
        let modal = await this.showModal(FormImport);
        let dismissed = await modal.onDidDismiss();
        if (dismissed && dismissed.data) {
          this.loadForms();
        }
      } else {
        this.showUpgrade(this.importForm);
      }
    },
    async showUpgrade(callback) {
      let alert = await this.$ionic.alertController.create({
        header: "Upgrade Required",
        message: "Looks like you've already used your one free form, upgrade to the paid version so you can create as many forms as you need. Heck yeah!",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "alert-button-cancel"
          },
          {
            text: "Upgrade",
            cssClass: "alert-button-primary",
            handler: () => {
              this.userUpgrade();
            }
          }
        ]
      });
      alert.present();
    },
    showForm(form) {
      this.showPage(`/forms/${form.id}`);
    },
    async userUpgrade() {
      await this.showModal(UserUpgrade);
    },
    async segmentChanged(event) {
      this.segment = event.detail.value;
      let loading = await this.showLoading();
      await this.loadForms();
      loading.dismiss();
    }
  }
};
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
}
h2 {
  color: #888888;
}
ion-segment {
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  ion-segment-button {
    font-size: 15px;
  }
  ion-label {
    font-size: 15px;
    font-weight: 500;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  ion-icon {
    font-size: 17px;
    width: 1.2em;
    height: 1.2em;
    margin-bottom: -4px;
    margin-right: 4px;
  }
}
</style>
